module.exports = __webpack_public_path__ + "media/images/games/fifa-21/hiw-1-ec7b8df61cdc0dee841d945bb0d949c5.jpg";